import { render, staticRenderFns } from "./SbSplashScreen.vue?vue&type=template&id=e808c4e6&scoped=true&"
import script from "./SbSplashScreen.vue?vue&type=script&lang=js&"
export * from "./SbSplashScreen.vue?vue&type=script&lang=js&"
import style0 from "./SbSplashScreen.vue?vue&type=style&index=0&id=e808c4e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e808c4e6",
  null
  
)

component.options.__file = "SbSplashScreen.vue"
export default component.exports